export default __webpack_public_path__ + "static/Electronics-397e3a909ae0b63e0f3bc56792e1272e.png";